import { render, staticRenderFns } from "./HiboFlap.vue?vue&type=template&id=6614e8b0&"
import script from "./HiboFlap.vue?vue&type=script&lang=ts&"
export * from "./HiboFlap.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports